module.exports = __webpack_public_path__ + "img/new-baleno-2022.cee4fdb1.svg";